// <script src="//shopfy-features.myshopify.com/cdn/shop/t/2/assets/bb__magic-city.js" defer="defer"></script>
console.log('feature')